import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
	cardContainer: {
		backgroundColor: tokens.colorPaletteMinkBorderActive,
		height: "220px",
		width: "308px",
		position: "fixed",
		zIndex: 999999,
		right: "12px",
		bottom: "12px",
		color: tokens.colorNeutralBackground1,
		borderBottomLeftRadius: tokens.borderRadiusLarge,
		borderBottomRightRadius: tokens.borderRadiusLarge,
	},

	innerContainer: {
		padding: "14px 32px 16px",
	},

	buttons: {
		position: "fixed",
		bottom: "24px",
		width: "104px",
	},

	avatar: {
		margin: "24px",

		"& > span": {
			color: tokens.colorNeutralBackground1,
			backgroundColor: tokens.colorPaletteBeigeBorderActive,
			fontSize: "30px",
		},
	},

	icon: {
		position: "fixed",
		right: "22px",
		paddingTop: "8px",
	},

	message: {
		paddingTop: "8px",
	},
	contactName:{
		maxWidth: "90% !important"
	}
});
